import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayForm,
  GTMEventGlycerinFormSubmitClick,
} from '@packages/tracking/src/types/events';

export const useRatingTracking = () => {
  const dispatchTracking = useTracking();

  const label = 'Kundenbewertungen';

  const trackGlycerinButtonClick = ({
    category,
    detail,
  }: Pick<GTMEventGlycerinButtonClick['ButtonClickData'], 'category' | 'detail'>) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category,
        detail,
        label,
      },
    });
  };

  const trackGlycerinDisplayForm = () => {
    dispatchTracking<GTMEventGlycerinDisplayForm>({
      event: 'DisplayForm',
      DisplayFormData: {
        category: 'Bewertungsformular',
        label,
      },
    });
  };

  const trackGlycerinFormSubmitClick = () => {
    dispatchTracking<GTMEventGlycerinFormSubmitClick>({
      event: 'FormSubmitClick',
      FormSubmitClickData: {
        category: 'Bewertungsformular',
        detail: 'Bewertung abgeben',
        label,
      },
    });
  };

  return {
    trackGlycerinButtonClick,
    trackGlycerinDisplayForm,
    trackGlycerinFormSubmitClick,
  };
};
